import $ from "jquery";

import render_topic_icon from "../templates/topic_icon.hbs";

import * as emoji from "./emoji.ts";
import * as emoji_picker from "./emoji_picker.ts";
import * as topic_appearance from "./topic_appearance.ts";

let selected_emoji: topic_appearance.Appearance["emoji"];

export function get(): topic_appearance.Appearance | undefined {
    const colors = Object.fromEntries(topic_appearance.color_fields.map((field) => {
        const value = $(`#topic_permissions_${field}`).val();
        return [field, value === "custom" ? $(`#topic_permissions_custom_${field}`).val() : value || null];
    }));
    const icon = $("#topic_permissions_icon").val() || null;
    const parsed = topic_appearance.appearance_schema.safeParse({
        icon, icon_color: null, ...colors, emoji: icon === "emoji" ? selected_emoji : null,
    });
    return parsed.success && (icon !== "emoji" || selected_emoji) ? parsed.data : undefined;
}

export function get_file(): File | undefined {
    if ($("#topic_permissions_icon").val() !== "custom") {
        return undefined;
    }
    return $("#topic_permissions_icon_file").prop("files")?.[0] as File | undefined;
}

export function initialize(
    appearance: topic_appearance.Appearance & {
        icon_url?: string | null;
        icon_format?: "svg" | "webp";
    },
): void {
    const $icon = $("#topic_permissions_icon");
    const $file = $("#topic_permissions_icon_file");
    const form = $("#topic_permissions_form")[0];
    selected_emoji = appearance.emoji;
    $file.val("");
    $icon.val(appearance.icon ?? "");
    const update_preview = (): void => {
        const file = get_file();
        const is_webp = $icon.val() === "custom" && (file
            ? file.type === "image/webp" || /\.webp$/i.test(file.name)
            : appearance.icon_format === "webp");
        for (const field of ["icon_color_light", "icon_color_dark"]) {
            $(`#topic_permissions_${field}`).prop("disabled", !$icon.val() || is_webp || $icon.val() === "emoji");
            $(`#topic_permissions_custom_${field}`).prop("disabled", !$icon.val() || is_webp || $icon.val() === "emoji");
        }
        const selected = get();
        const preview = topic_appearance.display_appearance_schema.safeParse(
            selected ? {...selected, icon_url: appearance.icon_url} : undefined,
        );
        const changed_svg_color = selected?.icon === "custom" && !is_webp &&
            (["light", "dark"] as const).some((theme) => {
                const old = appearance[`icon_color_${theme}`] === undefined
                    ? appearance.icon_color : appearance[`icon_color_${theme}`];
                return selected[`icon_color_${theme}`] !== old;
            });
        $("#topic_permissions_icon_preview").html(
            preview.success && !file && !changed_svg_color ? render_topic_icon(preview.data) : "",
        );
    };
    for (const field of topic_appearance.color_fields) {
        const color = appearance[field] ?? (
            field.startsWith("icon_") && appearance[field] === undefined ? appearance.icon_color : null
        );
        const $select = $(`#topic_permissions_${field}`);
        const $custom = $(`#topic_permissions_custom_${field}`);
        $select.val(color ?? "");
        $custom.val(color ?? "#000000");
        if ($select.val() === null) {
            $select.val("custom");
        }
        $select.on("change", update_preview);
        const update_custom = (): void => {
            $select.val("custom");
            update_preview();
        };
        $custom.on("input", update_custom);
        $custom.on("change", update_custom);
    }
    $("#topic_permissions_choose_emoji").on("click", function () {
        emoji_picker.toggle_emoji_popover(this, undefined, {placement: "bottom"}, (name) => {
            // A selection from a closed/replaced dialog must not touch another form.
            if (!form?.isConnected || $("#topic_permissions_form")[0] !== form) {
                return;
            }
            const details = emoji.get_emoji_details_by_name(name);
            selected_emoji = {
                emoji_name: details.emoji_name,
                emoji_code: details.emoji_code,
                reaction_type: details.reaction_type,
            };
            $icon.val("emoji");
            $file.val("");
            update_preview();
        });
    });
    $icon.on("change", () => {
        if ($icon.val() !== "custom") {
            $file.val("");
        }
        update_preview();
    });
    $file.on("change", () => {
        if ($file.prop("files")?.length) {
            $icon.val("custom");
        }
        update_preview();
    });
    update_preview();
}
